<template>
  <ul class="nav navbar-nav">
    <li class="nav-item dropdown notifications-menu">
      <a class="nav-link dropdown-toggle" href="javascript:void(0);" @click.stop="toggleNotifications">
        <i class="fas fa-bell"></i>
        <span class="notification-badge badge badge-danger">{{ notificationArray.length }}</span>
      </a>
      <ul class="dropdown-menu" v-if="showNotifications" @click.stop>
        <li class="header">You have {{ notificationArray.length }} new notifications</li>
        <li>
          <!-- Inner menu: contains the actual data -->
          <div v-bar preventParentScroll="true"> <!-- el1 -->
            <div class="vuebar-container"> <!-- el2 -->
              <NotificationRow v-for="notification in notificationArray" :key="notification.id" :notificationModule="notification.module" :notificationText="notification.notification"/>
            </div>
            <!-- dragger will be automatically added here -->
          </div>
        </li>
        <li class="footer"><a href="#">View all</a></li>
      </ul>
    </li>
  </ul>
</template>

<script>
// @ is an alias to /src
import NotificationRow from '@/components/nav/NotificationRow.vue'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'Notifications',
  components: {
    NotificationRow
  },
  props: {
    notificationArray: Array
  },
  data() {
    return {
      showNotifications: false
    }
  },
  computed: {
    
  },
  mounted() {
    EventBus.$on(['app-click','settings-click', 'toggle-action'], () => {
      this.showNotifications = false;
    });
  },
  methods: {
    toggleNotifications: function() {
      EventBus.$emit('notifications-click');
      this.showNotifications = this.showNotifications ? false : true;
    }
  }
}
</script>
